export interface TextContent {
    text: string
    backgroundColor: string
    backgroundImageId: string
    backgroundImage: {
        attributes: {
            publicUrl: string
            publicUrlBySize: PublicUrlBySize
        }
    }
}

export interface ImageContent {
    imageId: string
    alignment: "center" | "left" | "right"
    size: string 
    linkUrl: string
    image: {
        id: string
        type: string
        attributes: {
            publicUrl: string
            publicUrlBySize: PublicUrlBySize
        }
    }
}

export interface PublicUrlBySize {
    "50x50": string
    "85x85": string
    "150x150": string
    "640x480": string
    "1280x800": string
}

export type Content = TextContent | ImageContent

export enum ContentType {
    TEXT = "text",
    IMAGE = "image",
}

export enum VerticalAlignment {
    TOP = "top",
    MIDDLE = "middle",
    BOTTOM = "bottom",
}

export interface Cell {
    contentType: ContentType
    cellContent: Content
}

export interface Value {
    verticalAlignment: VerticalAlignment,
    cells: Cell[] 
}

export interface TextAndImageRowContent extends Value {
    nbColumns: number
}

export interface Section {
    id: string
    type: string
    attributes: {
        accountId: string
        content: TextAndImageRowContent
        contentType: string
        internalName: string
        rank: number
    }
}








// WEBPACK FOOTER //
// ./src/template/sections/content/text-and-image-row/types.ts